export const ADD_INBOX = 'ADD_INBOX';
export const APPEND_INBOX = 'APPEND_INBOX';
export const APPEND_TASK = 'APPEND_TASK';
export const UPDATE_INBOX = 'UPDATE_INBOX';
export const UPDATE_TASK = 'UPDATE_TASK';
export const APPEND_RESERVATION = 'APPEND_RESERVATION';
export const APPEND_ROOMINVITE = 'APPEND_ROOMINVITE';
export const REMOVE_ROOMINVITE = 'REMOVE_ROOMINVITE';
export const APPEND_CALL = 'APPEND_CALL';
export const REMOVE_CALL = 'REMOVE_CALL';
export const UPDATE_CALL = 'UPDATE_CALL';
export const ADD_OUTGOING_CALL = 'ADD_OUTGOING_CALL';
export const REMOVE_OUTGOING_CALL = 'REMOVE_OUTGOING_CALL';
export const MESSAGE_SEEN_INBOX = 'MESSAGE_SEEN_INBOX';
export const MESSAGE_NEW_INBOX = 'MESSAGE_NEW_INBOX';
export const UPDATE_MESSENGER_SEQUENCE = 'UPDATE_MESSENGER_SEQUENCE';




export function appendInbox(config, type) {
    return { type: APPEND_INBOX, config, model: type };
}
export function addInbox(inboxes, messengers, hub) {
    return { type: ADD_INBOX, inboxes, messengers, hub };
}


export function updateInbox(inbox) {
    return { type: UPDATE_INBOX, inbox };
}

export function messageSeenInbox(info) {
    return { type: MESSAGE_SEEN_INBOX, info };
}


export function messageNewInbox(info, isSender) {
    return { type: MESSAGE_NEW_INBOX, info, isSender };
}


export function updateMessengerSequence(id, sequence, hubSequence) {
    return { type: UPDATE_MESSENGER_SEQUENCE, id, sequence, hubSequence };
}


export function appendTask(tasks) {
    return { type: APPEND_TASK, tasks };
}
export function updateTask(config) {
    return { type: UPDATE_TASK, config };
}
export function appendReservation(reservation) {
    return { type: APPEND_RESERVATION, reservation };
}
export function appendRoomInvite(room) {
    return { type: APPEND_ROOMINVITE, room };
}
export function removeRoomInvite(room) {
    return { type: REMOVE_ROOMINVITE, room };
}
export function appendCall(room) {
    return { type: APPEND_CALL, room };
}
export function removeCall(room) {
    return { type: REMOVE_CALL, room };
}
export function updateCall(room) {
    return { type: UPDATE_CALL, room };
}
export function addOutgoingCall(config) {
    return { type: ADD_OUTGOING_CALL, config };
}
export function removeOutgoingCall(config) {
    return { type: REMOVE_OUTGOING_CALL, config };
}